const { IndividualObjectiveScoreType } = require("@helpers/_constants");
const { useMemo, useCallback } = require("react");

export const MAX_BY_SCORE_TYPE = {
  [IndividualObjectiveScoreType.RATING_3_STARS]: 3,
  [IndividualObjectiveScoreType.RATING_4]: 4,
  [IndividualObjectiveScoreType.RATING_5]: 5,
  [IndividualObjectiveScoreType.RATING_10]: 10,
  [IndividualObjectiveScoreType.RATING_100]: 100,
  [IndividualObjectiveScoreType.NOT_APPLICABLE]: 0,
};

export function useScoreMapper({ scoreType, score }) {
  const maxValue = useMemo(() => {
    return MAX_BY_SCORE_TYPE[scoreType];
  }, [scoreType]);

  const scale = useMemo(() => {
    return maxValue ? +(100 / maxValue).toFixed(2) : 0;
  }, [maxValue]);

  const inputValue = useMemo(() => {
    return scale && score !== null ? Math.round(score / scale) : null;
  }, [scale, score]);

  const mapScoreToPercent = useCallback(
    (value) => {
      return scale ? Math.round(+value * scale) : null;
    },
    [scale],
  );

  return {
    inputValue,
    mapScoreToPercent,
  };
}
